import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import Swiper from 'Swiper';
if(bowser.msie === true) {
	$('body').addClass('ie');
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
$(window).on('load',function(){
	const gnaviPC = $('.gnavi_pc > *').clone();
	const snsLink = $('.footer-links > *').clone();
	$('.spnavi #scroller #scroller-inner')
	.append(gnaviPC)
	.append(snsLink);

	let param = {
		target:'#spnavi',
		trigger:'.btn_sp_navi',
		filter:'resposive_flg',
		speed:200,
		fixer:100
	};
	const spnavi = new SpNavi(param);
	spnavi.exec();
});

const mySwiper = new Swiper ('.swiper-container', {
	effect: "fade",
	fade:　{
		crossFade: true
	},
	loop:true,
	autoplay:6000,
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev'
})

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
const link_icon = require('./link_icon');
link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */

$(window).on('load',function(){
	if($('#map_1').length > 0){
		let map_options = {
			target : 'map_1',
			center :  {lat:35.010824 , lng:135.759710},
			pins : [
				{ lat:35.024932,lng:135.753404,title:'Impact Hub Kyoto',link:"https://www.google.co.jp/maps/place/Impact+Hub+Kyoto/@35.0248754,135.751199,17z/data=!3m1!4b1!4m5!3m4!1s0x6001080d04e73283:0x8db275c0f40306f4!8m2!3d35.024871!4d135.753393" },{ lat:35.022518,lng:135.757801,title:'おづ maison du sake',link:"https://www.google.co.jp/maps/place/%E3%81%8A%E3%81%A5/@35.022487,135.7555859,17z/data=!3m1!4b1!4m5!3m4!1s0x6001087a37595555:0x2664e6bd243b121f!8m2!3d35.0224826!4d135.7577799" },{ lat:35.015705,lng:135.759918,title:'京都新聞ビル',link:"https://www.google.co.jp/maps/place/%E4%BA%AC%E9%83%BD%E6%96%B0%E8%81%9E%E7%A4%BE/@35.0136448,135.7582715,17z/data=!4m8!1m2!2m1!1z5Lqs6YO95paw6IGe44OT44Or!3m4!1s0x60010887bcf00189:0x61c4bc096c8d620b!8m2!3d35.015668!4d135.759911" },{ lat:35.009489,lng:135.728926,title:'島津製作所本社',link:"https://www.google.co.jp/maps/place/%E5%B3%B6%E6%B4%A5%E8%A3%BD%E4%BD%9C%E6%89%80+%E6%9C%AC%E7%A4%BE%E3%83%BB%E4%B8%89%E6%9D%A1%E5%B7%A5%E5%A0%B4/@35.0094148,135.7267318,17z/data=!3m1!4b1!4m5!3m4!1s0x600107b0abfd1817:0xb56f4d0893debb84!8m2!3d35.0094104!4d135.7289258" },{ lat:35.018455,lng:135.759209,title:'タイム堂',link:"https://www.google.co.jp/maps/place/%E3%82%BF%E3%82%A4%E3%83%A0%E5%A0%82/@35.0184067,135.7570039,17z/data=!3m1!4b1!4m5!3m4!1s0x6001087cfff58f59:0x22d61c26a32541d5!8m2!3d35.0184023!4d135.7591979" },{ lat:35.010586,lng:135.757433,title:'前田コーヒー御池店',link:"https://www.google.co.jp/maps/place/%E3%83%9E%E3%82%A8%E3%83%80%E3%82%B3%E3%83%BC%E3%83%92%E3%83%BC+%E5%BE%A1%E6%B1%A0%E5%BA%97/@35.0105381,135.7552393,17z/data=!3m1!4b1!4m5!3m4!1s0x600108847c8b03d7:0x7fc93fe98eb185cd!8m2!3d35.0105337!4d135.7574333" },{ lat:35.006366,lng:135.759299,title:'前田珈琲本店',link:"https://www.google.co.jp/maps/place/%E5%89%8D%E7%94%B0%E7%8F%88%E7%90%B2%E6%9C%AC%E5%BA%97/@35.0063268,135.7570943,17z/data=!3m1!4b1!4m5!3m4!1s0x6001089ad8ec800b:0xe390e71b8a203905!8m2!3d35.0063224!4d135.7592883" },
				{lat:34.984059 , lng:135.754311 , title:'ワコールスタディホール京都',link:'https://www.google.co.jp/maps/place/%E3%83%AF%E3%82%B3%E3%83%BC%E3%83%AB%E3%82%B9%E3%82%BF%E3%83%87%E3%82%A3%E3%83%9B%E3%83%BC%E3%83%AB%E4%BA%AC%E9%83%BD/@34.9840194,135.752096,17z/data=!3m1!4b1!4m5!3m4!1s0x600108a9a189f691:0x741f5ff3146bfc49!8m2!3d34.984015!4d135.75429'},
				{lat:35.017154 , lng:135.759236 , title:'ＮＯＫＵcafe',link:"https://www.google.co.jp/maps/place/noku+cafe+by+MAEDA'S+COFFEE/@35.011734,135.7548593,16z/data=!4m8!1m2!2m1!1z77yu77yv77yr77y1Y2FmZQ!3m4!1s0x6001087d0a995555:0xb946a2bde3dcf027!8m2!3d35.0171281!4d135.7592252"},
				{lat:35.010391 , lng:135.762944 , title:'月ヶ瀬堺町店',link:'https://www.google.co.jp/maps/place/%E6%9C%88%E3%83%B6%E7%80%AC+%E5%A0%BA%E7%94%BA%E5%BA%97/@35.0103604,135.76075,17z/data=!3m1!4b1!4m5!3m4!1s0x6001088fbc99683d:0x3f8640f2b85cab77!8m2!3d35.010356!4d135.762944'},
				{lat:35.029606 , lng:135.776948 , title:'喫茶ゆにおん',link:'https://www.google.co.jp/maps/place/%E3%83%A6%E3%83%8B%E3%82%AA%E3%83%B3/@35.0295625,135.7747703,17z/data=!3m1!4b1!4m5!3m4!1s0x6001085beaad58e5:0x798109d3481c437a!8m2!3d35.0295625!4d135.776959'}
			],
			settings : {
				zoom:17,
				icon:'',
				title:'map',
			}
		}

		let gmap = new Gmap(map_options);
		gmap.exec();
	}
});

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// const instagram = require('./instagram');
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');

(function($) {
$(function(){
	// let Request = {
	// 	send:function(obj){
	// 		var defer = $.Deferred();
	// 		$.ajax({
	// 			type: 'POST',
	// 			url: ajaxurl,
	// 			dataType: 'json',
	// 			context:obj,
	// 			success: defer.resolve,
	// 			error: defer.reject,
	// 			data : {
	// 				'action' : 'get_artist_img',
	// 				'_nonce': ajaxnounse
	// 			}
	// 		});
	// 		return defer.promise();
	// 	}
	// };
	// Request.send($(this)).then(
	// 	function(data1){
	// 		let interval = 600;
	// 		$('body').append(data1);
	// 		$('.js-bgimg').on('mouseenter',function(){
	// 			$('.bgimg').fadeOut(interval);
	// 			let id = $(this).data('bgimg');
	// 			let target = $('.bgimg_' + id);
	// 			target.fadeIn(interval);
	// 		}).on('mouseleave',function(){
	// 			$('.bgimg').fadeOut(interval);
	// 		});
	// 	},
	// 	function(data1){
	// 		console.log(data1);
	// 	}
	// );
	//
	let interval = 600;
	$('.js-bgimg').on('mouseenter',function(){
		$('.bgimg').fadeOut(interval);
		let id = $(this).data('bgimg');
		let target = $('.bgimg_' + id);
		target.fadeIn(interval);
	}).on('mouseleave',function(){
		$('.bgimg').fadeOut(interval);
	});
});
})(jQuery);


let lower_slide = require('./lower_slide');
lower_slide();

let home_slide = require('./home_slide');
home_slide();


$('.modal_close').on('click',function(){
	$('.modal_element').fadeOut('300',function(){
		$('#wrap').css({'position':'relative'});
	})
});



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js